import { render } from "./ProfileAparenciaTab.vue?vue&type=template&id=1352a59c&scoped=true&ts=true"
import script from "./ProfileAparenciaTab.vue?vue&type=script&lang=ts"
export * from "./ProfileAparenciaTab.vue?vue&type=script&lang=ts"

import "./ProfileAparenciaTab.vue?vue&type=style&index=0&id=1352a59c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1352a59c"]])

export default __exports__